module.exports = __webpack_public_path__ + "static/media/train5.0f4588f5.svg";